var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.date)?_c('p',{staticClass:"date"},[_c('i',{staticClass:"date__icon material-icons"},[_vm._v("access_time")]),_c('span',{staticClass:"date__text"},[_vm._v(_vm._s(_vm.date))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }